<template>
<div class="box">
   <div class="header">
      <div class="name">{{ftzName}}</div>
      <div class="pc">{{ftzBatch}}</div>
      <div class="main">Leading industry:{{chanYe}}</div>
      <div class="closes">
        <span><i class="el-icon-close" style="fontSize:30px;" @click="$router.go(-1)"></i></span>
        <div>All data in reports is from FTZ websites or authority institutes</div>
      </div>
   </div>
  <div  style="margin-top: 18px" class="bagF">
    <div id="titleBox">
      <span class="bigTitleInfo">FTZ Index Score</span>
    </div>

   <div class="chart-wrapper-2 clearfix">
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>FTZ First-grade Index</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
             <ChartRadar
              :id='"oneIndex"'
              :dataZoomFlag ='false'
              :keyCount ='oneIndexListVal'
              :keyName ='oneIndexListName'
              />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>Economic Strength</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
             <ChartBar
               :id='"economic"'
               :barColor="'#5FBAFA'"
               :dataZoomFlag ='false'
               :keyCount ='economicListVal'
               :keyName ='economicListName'
             />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>Urban Environment</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
             <ChartBar
               :id='"friendly"'
               :barColor="'#56D457'"
               :dataZoomFlag ='false'
               :keyCount ='friendlyListVal'
               :keyName ='friendlyListName'
             />
            </div>
          </div>
        </div>
      </div>
    </div>
   <div class="chart-wrapper-2 clearfix">
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>Business Environment</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
            <ChartBar
               :id='"business"'
               :barColor="'#F4A53F'"
               :dataZoomFlag ='false'
               :keyCount ='businessListVal'
               :keyName ='businessListName'
             />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>Quality Company Development</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
             <ChartBar
               :id='"highQuality"'
               :barColor="'#FC7373'"
               :dataZoomFlag ='false'
               :keyCount ='highQualityListVal'
               :keyName ='highQualityListName'
             />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-wrapper">
          <div class="title"><p>Innovation and Openness</p></div>
          <div class="inner">
            <div style="padding-top: 30px;height:100%;">
             <ChartBar
               :id='"innovation"'
               :barColor="'#9989FB'"
               :dataZoomFlag ='false'
               :keyCount ='innovationListVal'
               :keyName ='innovationListName'
             />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 自贸区指标明细展示 -->
  <div class="bagF"  style="margin-top: 18px">
      <div id="titleBox">
          <span class="bigTitleInfo">FTZ Index Detail</span>
      </div>
  <div class="m-wrapper">
    <FtaComplexTable
      :tableData="queryList"
      :headColumn="headColumn"
      :spanMethod="1"
      :maxHeight="1000"
    />
  </div>
  </div>
  <!-- 自贸区企业经营状况 -->
  <div class="bagF" style="margin-top: 20px">
      <div id="titleBox">
          <span class="bigTitleInfo">FTZ Company Condition</span>
      </div>
  <div class="m-wrapper">
    <FtaComplexTable
      :tableData="queryListState"
      :headColumn="column"
      :sortMethod="1"
      :maxHeight="1000"
    />
  </div>
  </div>
</div>

</template>

<script>
import FtaTitle from '../component/FtaTitle'
import FtaComplexTable from '../component/FtaComplexTable'
import ChartBar from './ChartBar'
import ChartRadar from './ChartRadar'
import request from '../../../ftaUtils/http'
import baseUrl from '../../../ftaUtils/baseUrl'
export default {
  name: 'InvestmentRecommendDet',
  components: {
    FtaTitle,
    FtaComplexTable,
    ChartBar,
    ChartRadar
  },
  data () {
    return {
      ftzId :0,
      queryList:[],
      queryListState:[],
      headColumn:[
            {
                prop:'oneIndex',
                label:'First-grade Index',
                align:'center',
            },
            {
                prop:'twoIndex',
                label:'Second-grade Index',
                align:'center',
            },
            {
                prop:'granularity',
                label:'Granularity',
                align:'center',
            },
            {
                prop:'statYear',
                label:'Year',
                align:'center',
            },
            {
                prop:'val',
                label:'Index Value',
                align:'center',
                style:'color:#3447FF'
            },
            {
                prop:'valUnit',
                label:'Index Unit',
                align:'center',
            },

        ],
      column:[
            {
                prop:'companyName',
                label:'Company Name',
                align:'center',
            },
            {
                prop:'companySize',
                label:'Scale',
                align:'center',
            },
            {
                prop:'continuousIncrease',
                label:'Growth In Revenue And Profit',
                align:'center',
            },
            {
                prop:'total',
                label:'Annual report of operating revenue   (CNY)',
                align:'center',
                child:[
                  {
                    prop:'income3yearBefore',
                    label:'2017',
                    align:'center',
                    style:'color:#3447FF'
                  },
                  {
                    prop:'income2yearBefore',
                    label:'2018',
                    align:'center',
                    style:'color:#3447FF'
                  },
                  {
                    prop:'income1yearBefore',
                    label:'2019',
                    align:'center',
                    style:'color:#3447FF'
                  }
                ]
            },
            {
                prop:'total',
                label:'Annual report of profit revenue   (CNY)',
                align:'center',
                child:[
                  {
                    prop:'profit3yearBefore',
                    label:'2017',
                    align:'center',
                    style:'color:#3447FF'
                  },
                  {
                    prop:'profit2yearBefore',
                    label:'2018',
                    align:'center',
                    style:'color:#3447FF'
                  },
                  {
                    prop:'profit1yearBefore',
                    label:'2019',
                    align:'center',
                    style:'color:#3447FF'
                  }
                ]
            },

        ],
        oneIndexListName:[], //
        oneIndexListVal:[],
        economicListName:[], // 经济发展
        economicListVal:[],
        friendlyListName:[], // 城市环境友好
        friendlyListVal:[],
        businessListName:[], // 城市营商环境
        businessListVal:[],
        highQualityListName:[], // 城市营商环境
        highQualityListVal:[],
        innovationListName:[], // 城市营商环境
        innovationListVal:[],
        ftzName:'',
        ftzBatch:'',
        chanYe:''

    }
  },
  methods: {
    // 获取信息接口
    getInformation(){
      request('get', `${baseUrl.base_1}/advice/queryDetails/`+this.ftzId ).then(
        (res) => {
          const {
            businessDetailsYear,
            businessDetailsList,
            indexDetailsList ,
            economicList,
            friendlyList,
            businessList,
            highQualityList,
            innovationList,
            ftzName,
            ftzBatch,
            chanYe,
            oneIndexList
            } = res.data
          this.ftzName = ftzName;
          this.ftzBatch = ftzBatch;
          this.chanYe = chanYe;
          // 指标展示
          this.oneIndexListName = oneIndexList.map( el =>  { return {name:el.name}});
          this.oneIndexListVal = oneIndexList.map( el =>  { return el.val});
          // 经济发展实力
          this.economicListName = economicList.map( el =>  { return el.name});
          this.economicListVal = economicList.map( el =>  { return el.val});
          // 城市环境友好
          this.friendlyListName = friendlyList.map( el =>  { return el.name});
          this.friendlyListVal = friendlyList.map( el =>  { return el.val});
          // 城市营商环境
          this.businessListName = businessList.map( el =>  { return el.name});
          this.businessListVal = businessList.map( el =>  { return el.val});
          // 优质企业发展指标
          this.highQualityListName = highQualityList.map( el =>  { return el.name});
          this.highQualityListVal = highQualityList.map( el =>  { return el.val});
          // 创新开放活力
          this.innovationListName = innovationList.map( el =>  { return el.name});
          this.innovationListVal = innovationList.map( el =>  { return el.val});

          this.queryList = indexDetailsList;
          this.queryListState = businessDetailsList;

          let year = this.column;
          year[3].child.forEach((ele,index) =>{
            ele.label = (businessDetailsYear - (2-index)).toString()
          })
          year[4].child.forEach((ele,index) =>{
            ele.label = (businessDetailsYear - (2-index)).toString()
          })

        }
      )
    },
  },
  created () {
    // const TS02b1f2d3 = getCookieKey('TS02b1f2d3')
    // this.$store.commit('ftaToken', TS02b1f2d3)
    this.ftzId = this.$route.params.id
    // console.log('this.$route.param.id',this.$route.params.id)
  },
  mounted () {
    this.getInformation()
  }
}
</script>

<style src="../fta.css"  scoped></style>
<style lang="less"  src="../InvestmentRecommend/InvestmentRecommend.less"  scoped></style>
<style scoped lang="less">
.box{
  //background: #fff;
  // padding-bottom: 20px;
}
.header{
  height: 71px;
  background: #59b3ff;
  width: 100%;
}
.header .name{
  font-size: 30px;
  color: #fff;
  font-weight: 400;
  float: left;
  margin-left: 20px;
  line-height: 71px;
}
.header .pc{
  margin-left: 11px;
  height: 23px;
  max-width: 177px;
  background: #9cd2ff;
  color: #fff;
  font-size: 12px;
  line-height: 23px;
  text-align: center;
  float: left;
  margin-top: 24px;
  padding: 0px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header .main{
  float: left;
  margin-left: 11px;
  background: #97cfeb;
  color: #fff;
  height: 23px;
  line-height: 23px;
  padding: 0px 20px;
  margin-top: 24px;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header .closes{
  float: right;
  display: flex;
  justify-content: right;
  flex-direction: column;
  align-items: flex-end;
  text-shadow: none;
  margin-right: 20px;
  margin-top: 10px;
}

.header .closes div{
  font-size: 12px;
  color: #2161a5;
  // margin-top: 12px;
}
.el-icon-close{
  color: #fff;
  font-size: 18px;
}
.m-wrapper{
  margin: 20px;
  // padding: 20px 0px;
  // background: #fff;
  // box-shadow: 0px 1px 12px 0px rgba(0 0 0 0.1);
  // border-radius: 20px;
  // background: #FFFFFF;
  // -webkit-box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  // box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  // border-radius: 20px;
}
.chart-wrapper-2 {
  margin-top: 54px;
  padding: 0px 20px;
  display: flex;
  justify-content: space-between;
  .item {
    width: calc(100% / 3 - 50px);
    box-sizing: border-box;
    position: relative;
      .unit {
        position: absolute;
        right: 35px;
        top: -10px;
        z-index: 99;
        font-size: 12px;
        color: #000000;
      }

    .title {
      z-index: 99;
      margin: 0 34px;
      height: 48px;
      background-color: #E4E4E4;
      border-radius: 24px;
      position: relative;
      top: -11px;
      border: 1px solid #A8A8A8;

      > p {
        line-height: 48px;
        margin-bottom: 0;
        font-size: 14px;
        color: #000000;
        letter-spacing: -0.28px;
        text-align: center;
        font-weight: 400;
      }
    }

      .inner {
        position: relative;
        top: -20px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10);
        border-radius: 20px;
        height: 283px;
      }
    }
  }

  // .item:nth-of-type(1) {
  //   padding-right: 7.5px;
  // }

  // .item:nth-of-type(2) {
  //   padding-left: 7.5px;
  // }

@media screen and (max-width:1450px) {
.header {
  .name{
    font-size: 25px;
  }
  .main{
    max-width: 300px;
  }
}
}





#titleBox{
  width:98%;
  margin:0 0 0 1%;
  height:60px;
  line-height:60px;
  border-bottom: 1px solid #c6c6c6;
}
.bigTitleInfo{
  // font-family:SourceHanSansCN-Bold;
  font-size: 16px;
  color:#409EFF;
  letter-spacing:-0.32px;
  padding-left:20px;
  font-weight:bold;
}
 /deep/ .has-gutter{
  background-image: linear-gradient(90deg, #C1EDFF 2%, #8FDEFE 100%);
}
/deep/ .has-gutter tr th,/deep/ .has-gutter tr {
  background: none !important;
}
.bagF{
  background: #fff;
  padding-bottom:10px;
}
</style>
